// extracted by mini-css-extract-plugin
module.exports = {"cell":"DropdownLinkCell_cell__1t7r7"};